import { render, staticRenderFns } from "./MetaCohortPage.vue?vue&type=template&id=a0986bf2"
import script from "./MetaCohortPage.vue?vue&type=script&lang=js"
export * from "./MetaCohortPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports